import type { MapDispatchToPropsFunction } from 'types/redux';
import { HelpWidgetApiKey } from '#packages/apis';
import * as stateManagement from '#packages/stateManagement';
import { dispatchEditorAPI } from '../../topBarComponent/topBarMapper';
import type { HelpWidgetOwnProps } from './helpWidget';

export interface HelpWidgetDispatchProps {
  startWelcomeTour: () => Promise<undefined>;
  openNewReleasesFeed: () => void;
}

const mapDispatchToProps: MapDispatchToPropsFunction<
  HelpWidgetDispatchProps,
  HelpWidgetOwnProps
> = (dispatch) => ({
  startWelcomeTour: dispatchEditorAPI(dispatch, (editorAPI) => {
    return editorAPI.host.getAPI(HelpWidgetApiKey).startWelcomeTour();
  }),
  openNewReleasesFeed() {
    dispatch(
      stateManagement.panels.actions.openRightPanel(
        'rEditor.NewReleasesFeedPanel',
      ),
    );
  },
});

export { mapDispatchToProps };
